// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import Select from '../controls/Select'
import styled, { type StyledComponent } from 'styled-components'
import type { ConditionType, OptionType } from '../types'
import matchesNotFloat from '../controls/FloatValueMatcher'

const MetricsConditionWrapper: StyledComponent<Object, any, any> = styled.div`
  width: 100%;
`

const Name: StyledComponent<Object, any, any> = styled.div`
  padding-right: 5px;
  display: table-cell;
  width: 10%;
  vertical-align: middle;
`

const PeriodPrefix: StyledComponent<Object, any, any> = styled.div`
  display: table-cell;
  width: 2%;
  vertical-align: middle;
`

const Period: StyledComponent<Object, any, any> = styled.div`
  display: table-cell;
  width: 8%;
  vertical-align: top;
`

const Comparison: StyledComponent<Object, any, any> = styled.div`
  display: table-cell;
  width: 5%;
  vertical-align: top;
  padding-left: 5px;
`

const Value: StyledComponent<Object, any, any> = styled.div`
  display: table-cell;
  width: 5%;
  vertical-align: top;
  padding-left: 5px;

  .input-item {
    height: 36px;
  }
`

type Props = {|
  t: Function,
  condition: ConditionType,
  options: Array<OptionType>,
  isOnlyInfo?: boolean,
  disabled?: boolean,
  onChange: Function
|}

export default class MetricsCondition extends Component<Props> {
  render() {
    const { isOnlyInfo, options, condition, disabled, t } = this.props

    if (isOnlyInfo) {
      return <div>{this.shortDescription()}</div>
    }

    return (
      <MetricsConditionWrapper>
        <Name>
          <Select
            value={condition.name || 'impressions'}
            options={options}
            disabled={disabled}
            onChange={(value) => this.nameChanged(value)}
          />
        </Name>
        <PeriodPrefix>
          <span>{t('period_prefix')}</span>
        </PeriodPrefix>
        <Period>
          <Select
            value={condition.period || 'today'}
            disabled={disabled}
            options={this.periodOptions()}
            onChange={(val) => this.periodChanged(val)}
          />
        </Period>
        <Comparison>
          <Select
            value={condition.comparison}
            disabled={disabled}
            options={this.comparisonOptions()}
            onChange={(val) => this.comparisonChanged(val)}
          />
        </Comparison>
        <Value className="t-ValueInput">
          <input
            className="input-item input-item_full-width"
            value={condition.value || ''}
            disabled={disabled}
            onChange={(e) => this.valueChanged(e.target.value)}
          />
        </Value>
      </MetricsConditionWrapper>
    )
  }

  shortDescription() {
    let condition = this.props.condition
    let sign = '?'
    let t = this.props.t
    let period = ''

    if (condition.comparison === 'less') sign = '<'
    if (condition.comparison === 'more') sign = '>'
    if (_.includes(['total', 'today'], condition.period)) {
      period = t(condition.period)
    } else if (condition.period.match(/^last_(\d+)_day(s?)/)) {
      period = t('last_days', { smart_count: condition.period.split('_')[1] })
    } else {
      period = 'unknown'
    }

    return _.join([t(condition.name), t('period_prefix'), period, sign, condition.value], ' ')
  }

  nameChanged(name: string) {
    this.props.onChange && this.props.onChange({ ...this.props.condition, name })
  }

  comparisonChanged(value: string) {
    let condition = _.extend({ errors: [] }, this.props.condition)

    condition.comparison = value
    this.props.onChange && this.props.onChange(condition)
  }

  valueChanged(value: string) {
    if (matchesNotFloat(value)) return
    this.props.onChange && this.props.onChange({ ...this.props.condition, value })
  }

  comparisonOptions() {
    let t = this.props.t
    return [
      { id: 'less', name: t('less') },
      { id: 'more', name: t('more') }
    ]
  }

  periodOptions() {
    const { t } = this.props
    return [
      { id: 'total', name: t('total') },
      { id: 'today', name: t('today') },
      { id: 'last_1_day', name: t('last_days', { smart_count: 1 }) },
      { id: 'last_2_days', name: t('last_days', { smart_count: 2 }) },
      { id: 'last_3_days', name: t('last_days', { smart_count: 3 }) },
      { id: 'last_7_days', name: t('last_days', { smart_count: 7 }) },
      { id: 'last_14_days', name: t('last_days', { smart_count: 14 }) },
      { id: 'last_28_days', name: t('last_days', { smart_count: 28 }) },
      { id: 'last_30_days', name: t('last_days', { smart_count: 30 }) }
    ]
  }

  periodChanged(period: string) {
    this.props.onChange && this.props.onChange({ ...this.props.condition, period })
  }
}
